export const API_BASE_URL: string | undefined = import.meta.env.VITE_API_BASE_URL;

export const POSTHOG_KEY: string = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
export const POSTHOG_HOST: string = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;
